import React from "react";
import { withRouter } from "react-router";
import { Container, Typography, Button, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { COMMONERRORMESSAGE } from "./common/branding";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  errorIcon: {
    fontSize: 50, 
    color: "red"
  },
});

const ErrorPage = ({ componentStack, error, history }) => {
  console.error("Error:", error);
  console.error("Component Stack:", componentStack);

  const classes = useStyles();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm" className={classes.root}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <ErrorOutlineIcon className={classes.errorIcon} />
        <Typography variant="h4" gutterBottom>
          {COMMONERRORMESSAGE}
        </Typography>        
        <Button variant="contained" color="primary" onClick={handleGoBack}>
          Go Back
        </Button>
      </Box>
    </Container>
  );
};

export default withRouter(ErrorPage);
